module.exports = __webpack_public_path__ + "static/media/grip-horizontal.ea5687e8.svg";